export const variants = {
  PRINCIPAL_CONTRACTOR: '885570000',
  PRINCIPAL_DESIGNER: '885570001',
  DESIGNER: '885570002',
  CONTRACTOR_CONSTRUCTION: '885570003',
  CONTRACTOR_NON_CONSTRUCTION: '885570004',
  CARE: '885570005',
  GENERAL: '885570006'
};
